module.exports = __webpack_public_path__ + "img/alerts.d64f0a6c.svg";